/// <amd-module name="Dashboards/DashboardView/src/utilities/ConnectWithPageContext" />
import * as React from "react";
import { connect } from "react-redux";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";

/**
 * Provides page context to mapStateToProps and
 * produces a function that creates a connected component.
 */
export function connectWithPageContext<TState = {}, TOwnProps = {}, TMappedStateProps = {}, TDispatchProps = {}>(
    mapStateToPropsWithContext: (state: TState, ownProps: TOwnProps, pageContext: IVssPageContext) => TMappedStateProps,
    mapDispatchToProps: TDispatchProps
): (component: React.ComponentType<TOwnProps & TMappedStateProps & TDispatchProps>) => React.ComponentClass<TOwnProps> {
    return function(component: React.ComponentType<TOwnProps & TMappedStateProps & TDispatchProps>) {
        return class extends VssComponent<TOwnProps & IVssComponentProperties> {
            public connectedComponent: React.ComponentClass<TOwnProps>;

            constructor(props: any, context: IVssComponentContext) {
                super(props, context);

                const mapStateToProps = (state: TState, ownProps: TOwnProps) => mapStateToPropsWithContext(state, ownProps, this.context.pageContext);

                // @ts-ignore TypeScript 3.5 errors here.
                this.connectedComponent = connect(
                    mapStateToProps,
                    mapDispatchToProps
                )(component as any);
            }

            public render(): JSX.Element {
                return <this.connectedComponent {...this.props} />;
            }
        };
    };
}
